// extracted by mini-css-extract-plugin
module.exports = {"partner-box":"_securedpartners_partner-box__1FgJE","message":"_securedpartners_message__16AdR","partner-images":"_securedpartners_partner-images__3qxaE"};